import React from 'react';
import {FormattedHTMLMessage} from 'react-intl';
require(`../assets/${process.env.PAGE}/css/components/faq.css`);
import RequireLoanButton from '../components/RequireLoanButton.js';

    function Faq(props) {
        return (
            <div className="section">
                <div className="pd-main container relative">
                    <div>
                        <div className="row">
                            <div className="col-sm-12 text-center">
                                <h2>Preguntas frecuentes</h2>
                            </div>
                        </div>
                        <div className="row faq-row">
                            <div className="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-6 faq">
                                <FormattedHTMLMessage id="app.faq1" description="faq"/>                      
                            </div>

                            <div className="col-xs-offset-1 col-xs-10 col-sm-offset-0 col-sm-12 col-md-6 faq">
                                <FormattedHTMLMessage id="app.faq2" description="faq"/> 
                            </div>
                        </div>
                        <div className="row how_it_works__row">
                            <div className="col-xs-12 text-center">
                                <RequireLoanButton/>
                            </div>
                        </div>
                    </div>
                 </div>
            </div>
            );
    };

export default Faq;


/** WEBPACK FOOTER **
 ** ./src/components/Faq.js
 **/